import React from 'react';
import styled from 'styled-components';
import { boxShadow1, green, whitesmoke } from 'utils/style/colors';
import Icon from 'components/Icon';
import { IProviderTemplate } from 'store/templates/templatesSlice';

interface ITemplateListProps {
  templates: IProviderTemplate;
  onEditTemplate: (templateId: number) => () => void;
  onDeleteTemplate: (templateId: number, isRestore: boolean) => () => void;
}

const List = styled('ul')`
  border-radius: 10px;
  box-shadow: ${boxShadow1};
`;

const TemplateItem = styled('li')`
  background-color: var(--exact-white);
  border-bottom: 1px solid ${whitesmoke};
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:last-child {
    border: none;
  }
`;

const ItemActions = styled('span')`
  display: flex;
  align-items: center;
  & > i {
    margin-right: 0.5rem;
    color: silver;
    cursor: pointer;
    transition: 0.3s ease all;
  }
  & > i:hover {
    color: ${green};
  }
`;

const TemplatesList: React.FC<ITemplateListProps> = ({
  templates,
  ...restProps
}) => (
  <List>
    {Object.values(templates).map((template) => (
      <TemplateItem key={template.id}>
        <span>{template.name}</span>
        <ItemActions>
          <Icon type={'edit'} onClick={restProps.onEditTemplate(template.id)} />
          <Icon
            type={template.deleted ? 'rotate-cw' : 'trash'}
            onClick={restProps.onDeleteTemplate(template.id, template.deleted)}
          />
        </ItemActions>
      </TemplateItem>
    ))}
  </List>
);

export default TemplatesList;
